import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/api-client.config.ts';
import { GetPickemResponse } from '@/@types/api.types.ts';

type GetPickemProps = {
  pickemId: number;
};

export const getPickem = ({
  pickemId,
}: GetPickemProps): Promise<GetPickemResponse> =>
  api.get(`/admin/pickems/${pickemId}`);

export const useGetPickem = (pickemId: number) => {
  return useQuery({
    queryKey: ['getPickem', pickemId],
    queryFn: () => getPickem({ pickemId }),
    select: (response) => response.pickem,
    enabled: Boolean(pickemId),
  });
};
